import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  CircularProgress,
  Rating,
  FormLabel,
} from "@mui/material";

import SelectableSearch from "../../../Base/views/SelectableSearch";
import { grey } from "@mui/material/colors";
import { useDispatch } from "react-redux";
import { AddPmsFeedbackAction, UpdatePmsFeedbackAction } from "../../../../../store/Employee/PMSFeedback/Action";
import { getEmployeeId, getUserData } from "../../../Base/helper/baseFunctions";
import { GetEmployeesHelper } from "../../../Employee/helper/EmployeeHelper";

export default function RequestFeedback({
  currentFeedback,
  closeMode,
  setOpenPopup,
  feedbackType
}) {
  const dispatch = useDispatch();
  const userData = getUserData();
  const initialValues = {
    feedback_title: "",
    feedback_from: feedbackType === "Give" ? {feedback_from: userData?.employee_id, name: userData?.name, employee_id: userData?.employee_id} : "",
    feedback_to:  feedbackType === "Request" ? {feedback_to: userData?.employee_id, name: userData?.name, employee_id: userData?.employee_id} : "",
    feedback_type: "",
    feedback_rating: 0,
    feedback_comments: "",
    visibility: "",
  };

  const [feedbackData, setFeedbackData] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [addLoading, setAddLoading] = useState(false);
  const [employeesData, setEmployeesData] = useState({
    load: true,
    values: [],
  });
const [FeedbackTypes] = useState({
  load: false,
  values: [
    { value: "Positive", label: "Positive" },
    { value: "Constructive", label: "Constructive" },
    { value: "General", label: "General" },
    { value: "Appreciation", label: "Appreciation" },
    { value: "Improvement Needed", label: "Improvement Needed" },
    { value: "Peer Feedback", label: "Peer Feedback" },
    { value: "Manager Feedback", label: "Manager Feedback" },
  ],
});
  const validate = (fieldValues) => {
    let temp = { ...errors };
    if ("feedback_title" in fieldValues) {
      temp.feedback_title =
        fieldValues.feedback_title === "" ? "Feedback Title is required" : "";
    }
    if ("feedback_from" in fieldValues && feedbackType === "Request") {
      temp.feedback_from =
        fieldValues.feedback_from === "" ? "Feedback From is required" : "";
    }
    if ("feedback_to" in fieldValues && feedbackType === "Give") {
      temp.feedback_to =
        fieldValues.feedback_to === "" ? "Feedback To is required" : "";
    }
    if ("feedback_type" in fieldValues) {
      temp.feedback_type =
        fieldValues.feedback_type === "" ? "Feedback Type is required" : "";
    }
    if ("feedback_rating" in fieldValues) {
      temp.feedback_rating = !fieldValues.feedback_rating
        ? "Rating is required"
        : "";
    }
    if ("visibility" in fieldValues) {
      temp.visibility =
        fieldValues.visibility === "" ? "Visibility is required" : "";
    }
    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleInputChange = (event, value) => {
    if (
      ["feedback_type", "feedback_from", "feedback_to", "visibility"].includes(
        event
      )
    ) {
      if (value) {
        setFeedbackData({
          ...feedbackData,
          [event]: value,
        });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...feedbackData, [event]: value ? value : "" });
    } else {
      setFeedbackData({
        ...feedbackData,
        [event.target.name]: event.target.value,
      });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...feedbackData, [event.target.name]: event.target.value });
    }
  };
  const handleCancel = () => {
    setOpenPopup(false);
    closeMode();
    setFeedbackData(initialValues);
    setErrors([]);
  };
  const handlesubmit = () => {
    if (validate(feedbackData)) {
      setAddLoading(true);
      if (currentFeedback?.feedback_pk) {
        dispatch(
          UpdatePmsFeedbackAction({...feedbackData,
            feedback_from: feedbackData?.feedback_from?.employee_id,
            feedback_to: feedbackData?.feedback_to?.employee_id,
          }, (error, result) => {
            setAddLoading(false);
            if (!error && result?.data?.statuscode === 200) {
              setFeedbackData(initialValues);
              setOpenPopup(false);
            }
          })
        );
      } else {
        dispatch(
          AddPmsFeedbackAction({...feedbackData,
            feedback_from: feedbackData?.feedback_from?.employee_id,
            feedback_to: feedbackData?.feedback_to?.employee_id,
          }, (error, result) => {
            setAddLoading(false);
            if (!error && result?.data?.statuscode === 200) {
              setFeedbackData(initialValues);
              setOpenPopup(false);
            }
          })
        );
      }
    }
  };

  const handleEmployees = () => {
    GetEmployeesHelper({is_active: true}).then(res => {
      if(res?.data?.statuscode === 200){
          setEmployeesData({
        load: false,
        values: (res?.data?.data || [])?.filter(el => Number(el.employee_id) !== getEmployeeId()),
      });
      }
    })
      
  };

  useEffect(() => {
    if(currentFeedback?.feedback_pk){
      setFeedbackData({...currentFeedback,
        feedback_from: {feedback_from: currentFeedback?.feedback_from, name: currentFeedback?.feedback_from_empname, employee_id: currentFeedback?.feedback_from},
        feedback_to: {feedback_to: currentFeedback?.feedback_to, name: currentFeedback?.feedback_to_empname, employee_id: currentFeedback?.feedback_to},
        feedback_type: { value: currentFeedback?.feedback_type, label: currentFeedback?.feedback_type },
      })
    }
  },[currentFeedback]);
  return (
    <Box>
      <Grid container>
        <Grid item xs={12} md={6} sx={{ px: "0.75rem", py: "0.5rem" }}>
          <FormControl fullWidth>
            <SelectableSearch
              label="Feedback from"
              value={feedbackData?.feedback_from}
              fieldLabel="name"
              required={true}
              loading={handleEmployees}
              variant={"contained"}
              name="feedback_from"
              size="small"
              disabled={feedbackType === "Give" || currentFeedback?.feedback_pk} 
              data={employeesData}
              onChangeEvent={handleInputChange}
              {...(errors.feedback_from && {
                error: true,
                helperText: errors.feedback_from,
              })}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} sx={{ px: "0.75rem", py: "0.5rem" }}>
          <FormControl fullWidth>
            <SelectableSearch
              label="Feedback to"
              value={feedbackData?.feedback_to}
              fieldLabel="name"
              required={true}
               loading={handleEmployees}
              variant={"contained"}
              name="feedback_to"
              disabled={feedbackType === "Request" || currentFeedback?.feedback_pk}
              size="small"
              data={employeesData}
              onChangeEvent={handleInputChange}
              {...(errors.feedback_to && {
                error: true,
                helperText: errors.feedback_to,
              })}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={12} sx={{ px: "0.75rem", py: "0.5rem" }}>
          <FormControl fullWidth>
            <TextField
              id="outlined-basic"
              label="Feedback Title"
              value={feedbackData?.feedback_title}
              name="feedback_title"
              variant="outlined"
              size="small"
              required
              onChange={handleInputChange}
              {...(errors.feedback_title && {
                error: true,
                helperText: errors.feedback_title,
              })}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6} sx={{ px: "0.75rem", py: "0.5rem" }}>
          <FormControl fullWidth>
            <SelectableSearch
              label="Feedback Type"
              value={feedbackData?.feedback_type}
              fieldLabel="label"
              required={true}
              variant={"contained"}
              name="feedback_type"
              size="small"
              data={FeedbackTypes}
              onChangeEvent={handleInputChange}
              {...(errors.feedback_type && {
                error: true,
                helperText: errors.feedback_type,
              })}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6} sx={{ px: "0.75rem", py: "0.5rem" }}>
          <FormControl fullWidth error={!!errors?.visibility} size="small">
            <InputLabel id="visibility-type-label">Visibility *</InputLabel>
            <Select
              labelId="visibility-type-label"
              name="visibility"
              value={feedbackData?.visibility}
              label="Visibility"
              onChange={handleInputChange}
              disabled={currentFeedback?.feedback_pk}
            >
              <MenuItem value="Private">Private</MenuItem>
              <MenuItem value="Public">Public</MenuItem>
            </Select>
            <FormHelperText>{errors?.visibility}</FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6} sx={{ px: "1rem", py: "0.5rem" }}>
          <FormControl fullWidth error={!!errors?.feedback_rating}>
            <FormLabel sx={{ fontWeight: 500 }}>Rating</FormLabel>
            <Rating
              name="feedback_rating"
              value={feedbackData?.feedback_rating}
              onChange={(e, newValue) =>
                handleInputChange({
                  target: { name: "feedback_rating", value: newValue },
                })
              }
              size="medium"
            />
            {errors?.feedback_rating && (
              <FormHelperText>{errors.feedback_rating}</FormHelperText>
            )}
          </FormControl>
        </Grid>

        <Grid item xs={12} md={12} sx={{ px: "0.75rem", py: "0.5rem" }}>
          <FormControl fullWidth>
            <TextField
              multiline
              rows={2}
              name="feedback_comments"
              value={feedbackData?.feedback_comments}
              onChange={handleInputChange}
              label="Additional Message"
              placeholder="Write your feedback..."
              sx={{ width: "100%" }}
              {...(errors.feedback_comments && {
                error: true,
                helperText: errors.feedback_comments,
              })}
            />
          </FormControl>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          px: "0.75rem",
          py: "0.5rem",
        }}
      >
        <Button
          onClick={handleCancel}
          sx={{
            ":hover": { color: grey[50] },
          }}
          variant="outlined"
          className="mpl-secondary-btn"
        >
          Cancel
        </Button>
        <Button
          onClick={handlesubmit}
          variant="contained"
          color="primary"
          type="submit"
          className="mpl-primary-btn"
          disabled={addLoading}
          startIcon={
            addLoading ? <CircularProgress size={18} color="inherit" /> : null
          }
        >
          {currentFeedback ? "Update" : "Save"}
        </Button>
      </Grid>
    </Box>
  );
}
